import MojitoPresentation from 'mojito/presentation';

const { Text } = MojitoPresentation.Components;

const SuspendedSelectionLabel = ({ expired, mojitoTools: { stringResolver, config } }) => {
    const l10nKey = expired
        ? '$SUSPENDED_SELECTION_LABEL.TEXT_ON_EXPIRED'
        : '$SUSPENDED_SELECTION_LABEL.TEXT';
    return (
        <Text class="ta-SuspendedSelectionLabel" config={config.suspendedText}>
            {stringResolver.resolveString(l10nKey)}
        </Text>
    );
};

export default SuspendedSelectionLabel;
